import { createConnector } from 'wagmi';
import { injected } from 'wagmi/connectors';
import { metaMaskWallet } from '@rainbow-me/rainbowkit/wallets';

/**
 * Prefer the MetaMask browser extension (window.ethereum) on desktop.
 * RainbowKit's default metaMaskWallet uses the MetaMask SDK in headless mode,
 * which can hang on "Opening MetaMask…" when the extension popup is blocked.
 */
function getMetaMaskProvider() {
    if (typeof window === 'undefined') return undefined;
    const { ethereum } = window;
    if (!ethereum) return undefined;

    const providers = ethereum.providers;
    if (Array.isArray(providers)) {
        const match = providers.find(
            (p) =>
                p?.isMetaMask &&
                !p?.isBraveWallet &&
                !p?.isRabby &&
                !p?.isCoinbaseWallet,
        );
        if (match) return match;
    }

    if (ethereum.isMetaMask && !ethereum.isBraveWallet) {
        return ethereum;
    }

    return undefined;
}

export function hasMetaMaskExtension() {
    return Boolean(getMetaMaskProvider());
}

export function metaMaskExtensionWallet(options = {}) {
    const fallbackWallet = metaMaskWallet(options);
    const extensionInstalled = hasMetaMaskExtension();

    if (!extensionInstalled) {
        return fallbackWallet;
    }

    return {
        ...fallbackWallet,
        installed: true,
        createConnector: (walletDetails) =>
            createConnector((config) => ({
                ...injected({
                    target: () => {
                        const provider = getMetaMaskProvider();
                        if (!provider) {
                            throw new Error('MetaMask extension not found');
                        }
                        return {
                            id: 'metaMask',
                            name: 'MetaMask',
                            provider,
                        };
                    },
                })(config),
                ...walletDetails,
            })),
    };
}
